import { render } from "./TheatreDaysManagementPage.vue?vue&type=template&id=151513b4"
import script from "./TheatreDaysManagementPage.vue?vue&type=script&lang=js"
export * from "./TheatreDaysManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__